module.exports = {"component":"button-stateful","status":"prod","display-name":"Stateful Buttons","SLDS-component-path":"/components/button/#flavor-stateful","url-slug":"stateful-buttons"}


//////////////////
// WEBPACK FOOTER
// ./components/button-stateful/docs.json
// module id = 155
// module chunks = 0